/**
 * Dictionnaire FR → EN fusionné pour l'API TheMealDB
 */

import { translationsFRtoEN } from "./ingredientTranslationsFR.js";
import { translationsFRtoENPart2 } from "./ingredientTranslationsFR2.js";

export const ingredientTranslationsFRtoEN = {
  ...translationsFRtoEN,
  ...translationsFRtoENPart2,
};
